module.exports = __webpack_public_path__ + "619ca7a549d05ce8b4ce5d4493e16878.gif";